import { Brand } from '@/app/consts/brand.config';
import { environment } from '@/environments/environment';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';


 export function msalInstanceFactory(type: Brand) {
   const configs = environment.msal as any;
   const config = configs[type] || configs.cn;
   if (!config) {
     throw new Error(`MSAL configuration not found for brand: ${String(type)}`);
   }
   return new PublicClientApplication({
     auth: {
       clientId: config.clientId,
       authority: config.authority,
       redirectUri: environment.redirectUrl,
     },
     cache: {
       cacheLocation: 'localStorage',
     },
   });
 }
@Injectable({
  providedIn: 'root' 
})
export class DynamicMsalService {
    constructor(private msalService: MsalService) {}

    async login(scopes: string[] = [`User.Read`]){
        try {
            await this.msalService.instance.initialize();
            const loginResponse =  this.msalService.loginPopup({scopes}).toPromise();
            return loginResponse;
        } catch (error) {
            console.log('Login failed', error);
            throw error;
        }
    }

    // TODO
    async logout(){
        try {
            // await this.msalService.instance.initialize();
            await this.msalService.logoutPopup();
        } catch (error) {
            console.log('Logout failed', error);
            throw error;
        }
    }
}

